import { AxiosError, AxiosResponse } from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Service from '../../services';
import { APP_Config } from '../../utils/AppConfig';
import { catchError } from '../../utils/Utils';
import { BankUserContext } from '../../bankUserContext';

const ApiCallback =()=>{
  const bankUserContext = useContext(BankUserContext);
  const [redirection, setRedirection]= useState(false);
  const [loader,setloader]=useState(true);
 const service = new Service();
 const navigate = useNavigate();  
  const location= useLocation();

  useEffect(() => {
      const codeIndex= location.search.indexOf("=");
      const code=location.search.slice(codeIndex+1,location.search.length);
    service.postapicall(code,APP_Config().REACT_APP_CLIENT_ID)
    .then((response:AxiosResponse)=>{
      localStorage.setItem('token', response.data.access_token); 
      localStorage.setItem("refreshToken", response.data.refresh_token);
      bankUserContext.updateClientDetails(response.data.access_token);
      setloader(false);
      setRedirection(true);
      
    })
    .catch((error:AxiosError)=>{
      catchError(error,true)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])     
        return (
          <>          
          {(redirection)?navigate("/landing"):""}
          {/* {loader && <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />} */}
          </>            
        );
}

export default ApiCallback;